import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "description", "category"]
  static values = { 
    useCases: Array 
  }
  
  connect() {
    // Listen for change events from the select
    this.selectTarget.addEventListener('change', this.handleSelection.bind(this))
  }
  
  handleSelection(event) {
    const selectedName = event.target.value
    
    if (!selectedName) {
      this.descriptionTarget.value = ''
      this.categoryTarget.value = ''
      return
    }
    
    // Find matching use case
    const matchingUseCase = this.useCasesValue.find(uc => uc.name === selectedName)
    
    if (matchingUseCase) {
      // Found a matching global use case, populate description and category
      this.descriptionTarget.value = matchingUseCase.description || ''
      this.categoryTarget.value = matchingUseCase.category || ''
    } else {
      // Custom use case typed by user, clear description and set category to "Custom"
      this.descriptionTarget.value = ''
      this.categoryTarget.value = 'Custom'
    }
    
    // Trigger events to notify any listeners
    this.descriptionTarget.dispatchEvent(new Event('input', { bubbles: true }))
    this.descriptionTarget.dispatchEvent(new Event('change', { bubbles: true }))
    this.categoryTarget.dispatchEvent(new Event('input', { bubbles: true }))
    this.categoryTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }
  
  disconnect() {
    this.selectTarget.removeEventListener('change', this.handleSelection.bind(this))
  }
}